module.exports = __webpack_public_path__ + "img/orm-image.bca7c37d.webp";